import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { nextTick } from "vue";
import { container } from "tsyringe";

// entities
import useAuthenticationStore from "@/entities/user/infrastructure/userStore";

// key factory
import { AuthenticationQueryKeyStore } from "@/features/authentication/config/query-key";

// usecase
import { AttemptLogoutUsecase } from "@/features/authentication/services/usecase/AttemptLogoutUsecase";
import { EnforceLogoutUsecase } from "@/features/authentication/services/usecase/EnforceLogoutUsecase";

export const useMutationAttemptLogout = () => {
    // store
    const authenticationStore = useAuthenticationStore();

    const queryClient = useQueryClient();

    const attemptLogoutUsecase = container.resolve(AttemptLogoutUsecase);
    const enforceLogoutUsecase = container.resolve(EnforceLogoutUsecase);

    // 로그아웃을 시도할 예정인데, 여기에는 loading 이 return 되어야 하고 error 사항일 시 errorboundary 를 통해 처리되고자 한다.
    const {
        mutateAsync: attemptLogout,
        isPending,
        error,
    } = useMutation({
        ...AuthenticationQueryKeyStore.authentication_logout,
        mutationFn: () => attemptLogoutUsecase.execute(authenticationStore),
        onError: () => {
            queryClient.clear();
            enforceLogoutUsecase.execute(authenticationStore);
            return;
        },
    });

    return {
        attemptLogout,
        isPending,
        error,
    };
};
